import { Typography, Box, Grid } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Minimize from '@material-ui/icons/Minimize';
import AddIcon from '@material-ui/icons/Add';
import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";


const PatientFamilyHistory = props => {
    const [fhData, setFhData] = useState(false)
    const { t } = useTranslation();
    const [expandedPanel, setExpandedPanel] = useState(false);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedPanel(isExpanded ? panel : false);
    };
    useEffect(()=>{
        if(props.fhGeneralDiseases.length===0 && props.fhBehavioral.length===0 &&  props.fhCardiovascular.length===0 && props.fhEndocrine.length===0 && 
            props.fhGastrointestinal.length===0 &&  props.fhHematologic.length===0 && props.fhImmunologic.length===0 && props.fhNeurologic.length===0 &&
            props.fhOncologic.length===0 && props.fhPsychiatric.length===0 && props.fhRespiratory.length===0 && props.fhReproductive.length===0){
                setFhData(true);
        }else{
            setFhData(false);
        }
    },[props.fhGeneralDiseases,props.fhBehavioral,props.fhCardiovascular,props.fhEndocrine,props.fhGastrointestinal,props.fhHematologic,props.fhImmunologic,
        props.fhNeurologic,props.fhOncologic,props.fhPsychiatric,props.fhRespiratory,props.fhReproductive, fhData])

    return (
        <Box style={{ paddingTop: 10 }}>
            <Accordion onChange={handleAccordionChange('panel1')}>
                <AccordionSummary
                    expandIcon={
                        expandedPanel ? <Minimize /> :
                            <AddIcon />
                    }

                    aria-controls="panel1a-content"
                    id="panel1a-header"

                >
                    <Typography>Family History</Typography>

                </AccordionSummary>
                <AccordionDetails>
                    <Grid container>
                        <>
                        {
                            fhData ? <Box style={{textAlign:"center", width:"100%"}}>No Data</Box> :
                            <>
                            <>
                                {props.fhGeneralDiseases?.map((general, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhGeneralAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {general.disease}
                                                        </Box>
                                                    </Box>
                                                    <Box display={general.disease === 'None' || general.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "75%" }}>

                                                        <Box style={{ width: "25%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {general.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${general.heirs}${"."}`}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            <>
                                {props.fhBehavioral?.map((behavioral, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhBehavioralAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {behavioral.disease}
                                                        </Box>
                                                    </Box>
                                                    <Box display={behavioral.disease === 'None' || behavioral.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "75%" }}>

                                                        <Box style={{ width: "25%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {behavioral.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${behavioral.heirs}${"."}`}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            <>
                                {props.fhCardiovascular?.map((cardiovascular, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhCardiovascularAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {cardiovascular.disease}
                                                        </Box>
                                                    </Box>
                                                    <Box display={cardiovascular.disease === 'None' || cardiovascular.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "75%" }}>

                                                        <Box style={{ width: "25%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {cardiovascular.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${cardiovascular.heirs}${"."}`}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            <>
                                {props.fhEndocrine?.map((endocrine, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhEndocrineAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {endocrine.disease}
                                                        </Box>
                                                    </Box>
                                                    <Box display={endocrine.disease === 'None' || endocrine.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "75%" }}>

                                                        <Box style={{ width: "25%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {endocrine.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${endocrine.heirs}${"."}`}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            <>
                                {props.fhGastrointestinal?.map((gastrointestinal, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhGastrointestinalAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {gastrointestinal.disease}
                                                        </Box>
                                                    </Box>
                                                    <Box display={gastrointestinal.disease === 'None' || gastrointestinal.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "75%" }}>

                                                        <Box style={{ width: "25%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {gastrointestinal.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${gastrointestinal.heirs}${"."}`}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            <>
                                {props.fhHematologic?.map((hematologic, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhHematologicAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {hematologic.disease}
                                                        </Box>
                                                    </Box>
                                                    <Box display={hematologic.disease === 'None' || hematologic.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "75%" }}>

                                                        <Box style={{ width: "25%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {hematologic.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${hematologic.heirs}${"."}`}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            <>
                                {props.fhImmunologic?.map((immunologic, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhImmunologicAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {immunologic.disease}
                                                        </Box>
                                                    </Box>
                                                    <Box display={immunologic.disease === 'None' || immunologic.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "75%" }}>

                                                        <Box style={{ width: "25%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {immunologic.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${immunologic.heirs}${"."}`}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            <>
                                {props.fhNeurologic?.map((neurologic, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhNeurologicAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {neurologic.disease}
                                                        </Box>
                                                    </Box>
                                                    <Box display={neurologic.disease === 'None' || neurologic.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "75%" }}>

                                                        <Box style={{ width: "25%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {neurologic.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${neurologic.heirs}${"."}`}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            <>
                                {props.fhOncologic?.map((oncologic, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhOncologicAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {oncologic.disease}
                                                        </Box>
                                                    </Box>
                                                    

                                                    <Box display={oncologic.disease === 'None' || oncologic.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "50%"}}>

                                                        <Box style={{ width: "50%"}}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {oncologic.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${oncologic.heirs}${"."}`}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                    <Box display={oncologic.disease ==="Other" ? "block" : "none"} style={{ width: "25%"}}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Other Site of Cancer</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {oncologic.othersiteofOncologic}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            <>
                                {props.fhPsychiatric?.map((psychiatric, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhPsychiatricAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {psychiatric.disease}
                                                        </Box>
                                                    </Box>
                                                    <Box display={psychiatric.disease === 'None' || psychiatric.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "75%" }}>

                                                        <Box style={{ width: "25%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {psychiatric.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${psychiatric.heirs}${"."}`}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            <>
                                {props.fhRespiratory?.map((respiratory, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhRespiratoryAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {respiratory.disease}
                                                        </Box>
                                                    </Box>
                                                    <Box display={respiratory.disease === 'None' || respiratory.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "75%" }}>

                                                        <Box style={{ width: "25%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {respiratory.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${respiratory.heirs}${"."}`}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            <>
                                {props.fhReproductive?.map((reproductive, i) => {
                                    return (
                                        <>
                                            <>
                                                <Typography style={{ fontWeight: "bolder" }}>
                                                    {t('common.substantive.fhReproductiveAssessmentDisease')} {i + 1} :
                                                </Typography>
                                            </>
                                            <Box style={{ width: "100%" }}>
                                                <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                    <Box style={{ width: "25%" }}>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            <b>Disease</b>
                                                        </Box>
                                                        <Box style={{ display: "flex", justifyContent: "center" }}>
                                                            {reproductive.disease}
                                                        </Box>
                                                    </Box>
                                                    <Box display={reproductive.disease === 'None' || reproductive.disease === '' ? 'none' : 'block'} style={{ display: "flex", flexWrap: "wrap", width: "75%" }}>

                                                        <Box style={{ width: "25%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>{t('common.substantive.self')}</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {reproductive.self}
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ width: "50%" }}>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                <b>Family Members</b>
                                                            </Box>
                                                            <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                {`${reproductive.heirs}${"."}`} 
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    )
                                })}
                            </>
                            </>
                        }
                        

                        </>

                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Box>
    )


}

export default PatientFamilyHistory;